module.exports = __webpack_public_path__ + "img/carrousel-video-5.c7dea52e.png";